import apiV2, { apiV1 } from "api-v2";
import { showToast, processFormData } from "utils/helpers";
import {
	endPerformance,
	logPerformance,
	startPerformance,
} from "utils/logging";

export const getListCompanyData = async (type, params) => {
	try {
		let response = await apiV2.get(`${type}`, { params });
		if (response.status === 200) {
			return response.data.data;
		}
	} catch (e) {
		console.log(e);
		showToast(e?.response?.data?.message, "Error");
	}
};
export const getListProjectExperience = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, params] = queryKey;
	try {
		const startTime = startPerformance();
		const response = await apiV2.get(`project-experience`, { params });
		if (response.status === 200) {
			const endTime = endPerformance();
			logPerformance(startTime, endTime, "RFx - getListProjectExperience");
			return response.data.data;
		}
		throw new Error("Failed to fetch project experience");
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch project experience"
		);
	}
};

export const getListKeyPersonnels = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, params] = queryKey;
	try {
		const response = await apiV2.get(`key-personnel`, { params });
		if (response.status === 200) {
			return response.data.data;
		}
		throw new Error("Failed to fetch key personnel");
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch key personnel"
		);
	}
};

export const getPastProjectForRfx = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, { projectId, rfqId }] = queryKey;

	try {
		const response = await apiV1.get(
			`/past-projects/${projectId}?replacement=1&rfq_id=${rfqId}`
		);

		if (response.status === 200) {
			return response.data.data;
		}

		throw new Error("Failed to fetch past project for RFX");
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch past project for RFX"
		);
	}
};

export const getPastKeyPersonnelForRfx = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, { keyPersonnelId, rfqId }] = queryKey;

	try {
		const response = await apiV1.get(
			`/companies/key-personnel/${keyPersonnelId}?replacement=1&rfq_id=${rfqId}`
		);

		if (response.status === 200) {
			return response.data.data.key_personnel;
		}
		throw new Error("Failed to fetch key personnel for RFX");
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch key personnel for RFX"
		);
	}
};

export const saveProjectChangesForRfx = async (projectId, rfxId, values) => {
	try {
		// create a copy of values to avoid modifying the original
		const formValues = { ...values };

		// Add rfxId to the values
		formValues.rfq_id = rfxId;

		// Handle testimonials field - set to null if empty string
		if (formValues.testimonials === "") {
			formValues.testimonials = null;
		}

		// Use the processFormData helper to properly format the form data
		const formData = processFormData(formValues);

		const response = await apiV2.post(
			`/project-experience/${projectId}/save-replacement`,
			formData
		);

		if (response.status === 200) {
			const message =
				response.data?.message ||
				"Project changes saved successfully for this RFX";

			showToast(message, "Success", true);

			return {
				status: true,
				response: {
					message: message,
				},
				data: response.data,
			};
		}
	} catch (err) {
		showToast(
			err?.response?.data?.message || "Failed to save project changes",
			"error"
		);
		throw err;
	}
};

export const saveKeyPersonnelChangesForRfx = async (
	keyPersonnelId,
	rfxId,
	values
) => {
	try {
		const formValues = { ...values };

		// Add rfqId to the values
		formValues.rfq_id = rfxId;

		// We don't need to add roles if it's not in the form
		// Roles handling can be removed since it's not required by the API

		// Handle resume_file field
		if (formValues.resume_file === "" || formValues.resume_file === undefined) {
			formValues.resume_file = null;
		}

		// Handle resume field
		if (formValues.resume === "" || formValues.resume === undefined) {
			formValues.resume = null;
		}

		// Use the processFormData helper to properly format the form data
		const formData = processFormData(formValues);

		const response = await apiV2.post(
			`/key-personnel/${keyPersonnelId}/save-replacement`,
			formData
		);

		if (response.status === 200) {
			showToast(
				response.data.message || "Key personnel saved successfully",
				"Success",
				true
			);
			return response.data;
		}

		throw new Error("Failed to save key personnel changes");
	} catch (err) {
		showToast(
			err?.response?.data?.message || "Failed to save key personnel changes",
			"Error"
		);

		// Return the error for proper handling in the component
		if (err.response && err.response.data) {
			throw err.response.data;
		}
		throw err;
	}
};

export const getListCorporateDocument = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, params] = queryKey;
	try {
		const response = await apiV2.get(`corporate-document`, { params });
		if (response.status === 200) {
			return response.data.data;
		}
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch corporate documents"
		);
	}
};

export const getPastProjectById = async ({ queryKey }) => {
	// eslint-disable-next-line no-unused-vars
	const [_, pastProjectId] = queryKey;

	try {
		const response = await apiV1.get(`/past-projects/${pastProjectId}`);

		if (response.status === 200) {
			return response.data.data;
		}

		throw new Error("Failed to fetch past project");
	} catch (err) {
		throw new Error(
			err?.response?.data?.message || "Failed to fetch past project"
		);
	}
};
